import NewCandidatePage, { NewCandidateForm } from './NewCandidate.container';

export type NewCandidateFormType = NewCandidateForm;

export default NewCandidatePage;
